











import { computed, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { ROLES } from "@/const";
import { CreatorsListTab, CreatorsTabsEnum } from "../../types";

export default defineComponent({
  name: "CreatorsListTabs",
  props: {
    activeRole: { type: String, default: ROLES.CREATOR },
    activeTab: { type: String as () => CreatorsTabsEnum, default: CreatorsTabsEnum.ALL },
    total: { type: Object as () => Record<CreatorsTabsEnum, number>, required: true },
  },
  setup(props) {
    const tabs = computed<Array<CreatorsListTab & { total: number }>>(() => [
      {
        name: $t("All"),
        value: CreatorsTabsEnum.ALL,
        to: { name: "usersAll" },
        total: props.total[CreatorsTabsEnum.ALL],
      },
      ...(props.activeRole === ROLES.CREATOR
        ? [
            {
              name: $t("Live"),
              value: CreatorsTabsEnum.LIVE,
              to: { name: "usersLive" },
              total: props.total[CreatorsTabsEnum.LIVE],
            },
          ]
        : []),
      {
        name: $t("Online"),
        value: CreatorsTabsEnum.ONLINE,
        to: { name: "usersOnline" },
        total: props.total[CreatorsTabsEnum.ONLINE],
      },
      {
        name: $t("Recently active"),
        value: CreatorsTabsEnum.RECENTLY_ACTIVE,
        to: { name: "usersRecentlyActive" },
        total: props.total[CreatorsTabsEnum.RECENTLY_ACTIVE],
      },
    ]);
    return { tabs, showTotal: config.featureDiscoveryCreatorsCountInTabs };
  },
});
